enum CommonParams {
  PAGE = 'page',
  PAGE_FROM = 'pageFrom',
  PAGE_SIZE = 'pageSize',
  SORT_BY = 'sortBy',
  SORT_ORDER = 'sortOrder',
}

export default CommonParams;
